import { AbstractEvent } from './AbstractEvent';

export class AddToCartAfterSearch extends AbstractEvent {
  algoliaEvent = 'addedToCartObjectIDsAfterSearch';

  customEventName = 'add_to_card_after_search';
}
